<div fxLayout="column" class="dialog">
  @if (metadataLoading) {
    <busy-indicator page="true"></busy-indicator>
  }
  <h2>Add Item</h2>
  <form #form="ngForm">
    @if (!metadataLoading) {
      <metadata-panel ngModelGroup="pnl_addDialog" metadata="metadata" model="entity">
    </metadata-panel>
  }
</form>
@if (hasError) {
  <div class="error">{{saveError}}</div>
}

<div fxLayout="row" fxLayoutAlign="end center">
  <command-bar telemetry="CmdBar-Commands-AddItem-Inventory" [commands]="commands"></command-bar>
</div>
</div>
